export default __webpack_public_path__ + "static/media/128.6291d90a.jpg";